import { render, staticRenderFns } from "./solart-3d.vue?vue&type=template&id=09d04cf6&scoped=true&"
import script from "./solart-3d.vue?vue&type=script&lang=js&"
export * from "./solart-3d.vue?vue&type=script&lang=js&"
import style0 from "./solart-3d.vue?vue&type=style&index=0&id=09d04cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d04cf6",
  null
  
)

export default component.exports